module.exports = __webpack_public_path__ + "img/qysj_bg.2a6b945f.png";